export const ENVIRONMENT = process.env.REACT_APP_ENV;
export const VERSION = process.env.REACT_APP_COMMIT;

const ENVIRONMENT_CONFIG = {
  ENVIRONMENT,
  VERSION,
};

export default ENVIRONMENT_CONFIG;
